module.exports = __webpack_public_path__ + "img/record-fill.227d9800.svg";